var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.605 6.378a.375.375 0 00-.277-.128H11.5V5.192c0-.21.045-.45.383-.45h2.25a.33.33 0 00.262-.112.375.375 0 00.105-.255v-3A.375.375 0 0014.125 1h-3.248C7.277 1 7 4.075 7 5.013V6.25H5.125a.375.375 0 00-.375.375v3a.375.375 0 00.375.375H7v8.625a.375.375 0 00.375.375h3.75a.375.375 0 00.375-.375V10h2.512a.375.375 0 00.375-.338l.316-3a.375.375 0 00-.098-.284z",
    fill: "#fff"
  })));
}

export default SvgFacebookinline;